/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { MenuItem } from "@mui/material";
import cn from "clsx";
import { useSimpliCity } from "cms/hooks/use-simplicity";
import { ReportProblemLink } from "./report-problem-link";
import { ContactUsLink } from "./contact-us-link";
import { MobileMenuItem } from "./mobile-menu-item";

const HeaderMenuMobile = (props) => {

    const { show } = props;
    const { menu } = useSimpliCity();

    return (
        <div className={cn("mobile-menu", { open: show })}>
            <div className='mobile-menu-content'>
                <MenuItem className='header-nav-bar-links'>
                    <ReportProblemLink />
                </MenuItem>
                <MenuItem className='header-nav-bar-links'>
                    <ContactUsLink />
                </MenuItem>

                {menu.map((page) => {
                    return (
                        <MobileMenuItem key={page.title} level={1} page={page} />
                    );
                })}
            </div>
        </div>
    );
};

export { HeaderMenuMobile };
